import { useCallback, useContext, useMemo } from 'react';
import useSWR from 'swr';
import { AppContext } from 'providers/AppProvider';
import { ENTITY_TYPE } from 'consts';
import { isDev } from 'helpers/env.helpers';
import { LANGUAGES } from 'store/state';

export function useAml() {
	const ctx = useContext(AppContext);
	const { config, entityType, flowType, state, fetchRelations, goToNextPage, navigate } = ctx;
	const { context, language, user } = state;
	const showBTN = config.IS_EMPLOYEE_WEB || isDev(config.APP_ENV);
	const baseURL = config.API.getAMLQuestions;
	const lang = LANGUAGES.indexOf(language.language);
	const kt = context.kennitala || user.kennitala;
	const getQuestionnaireUrl = `${baseURL}/${kt}?amlLanguageCode=${lang}`;
	const { data, isLoading } = useSWR(getQuestionnaireUrl);

	const requestConfig: any = useMemo(
		() => ({
			baseURL,
			headers: { Authorization: `Bearer ${user.token}` },
			method: 'GET'
		}),
		[baseURL, user.token]
	);

	const onFinish = useCallback(() => {
		if (ENTITY_TYPE.INDIVIDUAL === entityType) {
			navigate(`/${flowType}/${entityType}/onboard`);
		} else {
			fetchRelations(true);
		}
	}, [entityType, flowType, fetchRelations, navigate]);

	const skip = useCallback(() => {
		if (ENTITY_TYPE.INDIVIDUAL === entityType) {
			navigate(`/${flowType}/${entityType}/onboard`);
		} else {
			goToNextPage();
		}
	}, [entityType, flowType, goToNextPage, navigate]);

	return {
		...ctx,
		data,
		getQuestionnaireUrl,
		isLoading,
		onFinish,
		requestConfig,
		showBTN,
		skip
	};
}
